import { IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { formatFileSize } from "utils/formatFileSize";
import { ExcelIcon, PdfIcon, WordIcon } from "components/Assets/generated";
import ImageIcon from "@mui/icons-material/Image";

function FileCard({ file, onDeleteFile, containerSx = {}, nameSx = {} }) {
  let icon = <></>;

  switch (file?.type) {
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      icon = <WordIcon />;

      break;
    case "application/msword":
      icon = <WordIcon />;

      break;
    case "application/pdf":
      icon = <PdfIcon />;
      break;
    case "image/jpeg" || "image/jpg" || "image/png" || "image/gif":
      icon = <ImageIcon />;
      break;

    default:
      icon = <ExcelIcon />;

      break;
  }
  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      justifyContent={"space-between"}
      sx={{
        p: 2,
        width: "348px",
        height: "75px",
        borderRadius: "6px",
        background: "#F6F6F6",
        ...containerSx,
      }}
    >
      <Stack direction={"row"} spacing={2}>
        {icon}
        <hgroup>
          <Typography
            sx={{
              fontSize: "14px",
              width: "230px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              ...nameSx,
            }}
          >
            {file.name}
          </Typography>
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "600",
              opacity: 0.7,
            }}
          >
            {formatFileSize(file.size)}
          </Typography>
        </hgroup>
      </Stack>
      <IconButton size="small" onClick={onDeleteFile.bind(this, file)}>
        <DeleteOutlineIcon />
      </IconButton>
    </Stack>
  );
}

export default FileCard;
